var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video_con"},[_c('video',{ref:"video",staticClass:"video",attrs:{"autoplay":"","controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }